/*
 * Copyright (C) 2024 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */

import React from 'react'
import type {InternalLtiConfiguration} from '../../model/internal_lti_configuration/InternalLtiConfiguration'

import {Lti1p3RegistrationOverlayStore} from '../../registration_overlay/Lti1p3RegistrationOverlayStore'
import {RegistrationModalBody} from '../../registration_wizard/RegistrationModalBody'
import {OverrideURIsConfirmation} from '../../registration_wizard_forms/OverrideURIsConfirmation'

export type OverrideURIsConfirmationWrapperProps = {
  overlayStore: Lti1p3RegistrationOverlayStore
  internalConfig: InternalLtiConfiguration
  reviewing: boolean
  hasClickedNext?: boolean
}

export const OverrideURIsConfirmationWrapper = React.memo(
  ({overlayStore, internalConfig}: OverrideURIsConfirmationWrapperProps) => {
    return (
      <RegistrationModalBody>
        <OverrideURIsConfirmation overlayStore={overlayStore} internalConfig={internalConfig} />
      </RegistrationModalBody>
    )
  },
)
